module.exports = __webpack_public_path__ + "src/assets/img/pix_copy_and_paste.0c1f80f0.svg";